var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("rect",{"y":"128","width":"298.667","height":"42.667"}))));
}

MinusInline.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 298.667 298.667","style":{"enableBackground":"new 0 0 298.667 298.667"},"xmlSpace":"preserve"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
